import Navigator from "./Navigator/Navigator";
import Screen from "./Screen/Screen";

const Selector = {
  Navigator,
  Screen,
};

export default Selector;
